import { AvatarWithInitials } from '@eluve/blocks';
import { Badge, Icon, Stack, Tag } from '@eluve/components';

import { PatientOptionInfo, getName, getPatientDetails } from './utils';

export const PatientOption: React.FC<PatientOptionInfo & { new?: boolean }> = (
  patient,
) => {
  const name = getName(patient);
  const patientDetails = getPatientDetails(patient);

  return (
    <Stack className="py-1" direction="horizontal" fullWidth={false} gap={4}>
      <AvatarWithInitials name={name} id={patient.id} />
      <Stack className="flex-1" gap={2}>
        <span className="font-semibold text-text-secondary privacy-text">
          {name}
        </span>
        {patientDetails && (
          <Tag
            color="gray"
            label={patientDetails}
            size="xs"
            className="text-xs font-medium text-text-primary"
          />
        )}
        {patient.new && (
          <Badge className="w-max">
            <Icon name="Plus" className="mr-1" />
            Create New
          </Badge>
        )}
      </Stack>
    </Stack>
  );
};
